import React, { useEffect, useRef } from 'react';
import { useCameraStore } from '../stores/cameraStore';

interface CameraManagerProps {
  isVideoOn: boolean;
}

const CameraManager: React.FC<CameraManagerProps> = ({ isVideoOn }) => {
  const { setCameraStream, clearCameraStream } = useCameraStore();
  const streamRef = useRef<MediaStream | null>(null);

  useEffect(() => {
    let isActive = true;

    const startCamera = async () => {
      try {
        const s = await navigator.mediaDevices.getUserMedia({ video: true });
        if (isActive) {
          streamRef.current = s;
          setCameraStream(s);
        } else {
          s.getTracks().forEach((track) => track.stop());
        }
      } catch (error) {
        console.error('Error starting camera:', error);
        clearCameraStream();
      }
    };

    const stopCamera = () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
        streamRef.current = null;
      }
      clearCameraStream();
    };

    // Start camera if video is on
    if (isVideoOn) {
      startCamera();
    } else {
      stopCamera();
    }

    return () => {
      isActive = false;
      // Ensure stream is stopped on component unmount
      if (streamRef.current) {
        stopCamera();
      }
    };
  }, [isVideoOn, setCameraStream, clearCameraStream]);

  return null;
};

export default CameraManager;

